const DB_LIMIT = 255;
const LONGTEXT_LIMIT = 8192; // 8 KBs
const NUMBER_LIMIT_CONST = 9999999999; // 10 digits

export enum InputLimits {
  // Default limits
  NUMBER_LIMIT = NUMBER_LIMIT_CONST,
  // Basic input limits
  TITLE_LIMIT = 120,
  DESCRIPTION_LIMIT = DB_LIMIT,
  KEYWORDS_LIMIT = DB_LIMIT,
  // SEO settings
  SEO_HEADER_SCRIPT = LONGTEXT_LIMIT,
  SEO_BODY_SCRIPT = LONGTEXT_LIMIT,
  // Google Analytics
  GA4_SCRIPT = LONGTEXT_LIMIT,
  // Authentication
  PASSWORD_LIMIT_MIN = 4,
  PASSWORD_LIMIT_MAX = 16,
  AUTH_PAGE_DESCRIPTION = DB_LIMIT,
}
